"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromLocalStorage = exports.setToLocalStorage = exports.getFromLocalStorage = exports.withPreventDefault = exports.stopKeyDownEvent = exports.stopEvent = exports.withConditional = exports.regexEscape = exports.randomString = exports.hashCode = void 0;
var React = __importStar(require("react"));
__exportStar(require("./colorUtils"), exports);
__exportStar(require("./schemaUtils"), exports);
__exportStar(require("./styledUtils"), exports);
var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
exports.hashCode = function (text, max) {
    var hash = 0;
    for (var index = 0; index < text.length; index++) {
        hash = text.charCodeAt(index) + ((hash << 5) - hash);
    }
    return (hash >> (text.length * 8)) & max;
};
exports.randomString = function (length) {
    if (length === void 0) { length = 16; }
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
exports.regexEscape = function (str) {
    return str.replace(matchOperatorsRe, '\\$&');
};
exports.withConditional = function (hoc, fn) {
    return function (Base) {
        var Wrapped = hoc(Base);
        return React.forwardRef(function (props, ref) {
            var Component = fn(props) ? Wrapped : Base;
            return React.createElement(Component, __assign(__assign({}, props), { ref: ref }));
        });
    };
};
exports.stopEvent = function (event) {
    event.preventDefault();
    event.stopPropagation();
};
exports.stopKeyDownEvent = function (e, keyCode, handler) {
    if (!e.defaultPrevented && e.keyCode === keyCode) {
        e.preventDefault();
        e.stopPropagation();
        if (handler) {
            handler();
        }
    }
};
exports.withPreventDefault = function (fn) { return function (e) {
    if (e && e.preventDefault) {
        e.preventDefault();
    }
    return fn();
}; };
exports.getFromLocalStorage = function (key) {
    try {
        var val = localStorage.getItem(key);
        if (val != null) {
            return JSON.parse(val);
        }
        return undefined;
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
};
exports.setToLocalStorage = function (key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    }
    catch (err) {
        console.error(err);
    }
};
exports.removeFromLocalStorage = function (key) {
    try {
        localStorage.removeItem(key);
    }
    catch (err) {
        console.error(err);
    }
};
